import React from 'react';
import { Modal, Backdrop, Fade, IconButton, Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import './SupportModal.scss';

const ModalContentBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[5],
}));

const CloseIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.white.main,
  top: theme.spacing(1),
  right: theme.spacing(1),
}));

const HeaderBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.white.main,
  padding: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

const ContactContainerBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  gap: theme.spacing(2),
}));


const SupportModal = ({ open, handleClose }) => {
  return (
    <Modal
      aria-labelledby="support-modal-title"
      aria-describedby="support-modal-description"
      className='d-flex align-items-center justify-content-center'
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={open}>
        <ModalContentBox className="modal-content">
          <CloseIconButton
            aria-label="close"
            className="position-absolute"
            onClick={handleClose}
            size="large"
          >
            <CloseIcon />
          </CloseIconButton>
          <HeaderBox sx={{ display: 'flex', alignItems: 'center' }}>
            <img alt="Covr Logo" src="/AdvisorImages/covr-logo-white.svg" />
            <Typography variant="h5" className="ms-5 font-weight-normal">
              Contact Covr
            </Typography>
          </HeaderBox>
          <ContactContainerBox>
            <Typography variant="body1">
              For support, please contact your Covr representative.
            </Typography>
          </ContactContainerBox>
        </ModalContentBox>
      </Fade>
    </Modal>
  );
};

export default SupportModal;
